import React from "react";
import styles from "./skillList.module.css";
import nodeText from "../../../assets/skiilsLogo/textLogo/nodejsText.png";
import reactJs from "../../../assets/skiilsLogo/textLogo/reactjsText.png";
import express from "../../../assets/skiilsLogo/textLogo/expressText.png";
import html from "../../../assets/skiilsLogo/textLogo/htmlText.png";
import css from "../../../assets/skiilsLogo/textLogo/cssText.png";
import mongo from "../../../assets/skiilsLogo/textLogo/mongoText.png";
import mysql from "../../../assets/skiilsLogo/textLogo/mysqlText.png";
import firebase from "../../../assets/skiilsLogo/textLogo/fireBASEtext.png";
import nextJs from "../../../assets/skiilsLogo/textLogo/nextText.png";
import jsText from "../../../assets/skiilsLogo/textLogo/jsText.png";
import pythonText from "../../../assets/skiilsLogo/textLogo/pythonText.png";
const SkillCarousel = () => {
  const skillsSet = [
    { name: "css", image: css },
    { name: "nextjs", image: nextJs },
    { name: "reactJs", image: reactJs },
    { name: "mongodb", image: mongo },
    { name: "python", image: pythonText },
    { name: "js", image: jsText },
    { name: "nodeJs", image: nodeText },
    { name: "expressJs", image: express },
    { name: "sql", image: mysql },
    { name: "html", image: html },
    { name: "nodeJs", image: nodeText },
    { name: "reactJs", image: reactJs },
    { name: "expressJs", image: express },
    { name: "nextjs", image: nextJs },
    { name: "js", image: jsText },
    { name: "html", image: html },
    { name: "css", image: css },
    { name: "mongodb", image: mongo },
    { name: "firebase", image: firebase },
    { name: "python", image: pythonText },
    { name: "sql", image: mysql },
    { name: "firebase", image: firebase },
  ];

  return (
    <div className={styles["carousel-container"]}>
      <div className={styles["carousel-header"]}>
        <p className={styles["carousel-title"]}>Skills | Technologies</p>
      </div>

      <div className={styles["carousel-wrapper"]}>
        <div className={styles["carousel-track"]}>
          {/* First set of skillsSet */}
          {skillsSet.map((skill, index) => (
            <div key={`first-${index}`} className={styles["company-logo"]}>
              <img
                src={skill.image}
                alt={skill.name}
                className={styles["logo-image"]}
              />
            </div>
          ))}

          {/* Duplicate set for seamless loop */}
          {skillsSet.map((skill, index) => (
            <div key={`second-${index}`} className={styles["company-logo"]}>
              <img
                src={skill.image}
                alt={skill.name}
                className={styles["logo-image"]}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkillCarousel;
